<script setup>
import { ref } from 'vue'
import { useEventListener } from '@vueuse/core'
import ActionButton from '@elements/ActionButton.vue'

const showScrollTop = ref(false)

useEventListener(
	window,
	'scroll',
	() => { showScrollTop.value = window.scrollY > ( window.innerHeight / 2 ) },
	{ passive: true }
)

function scrollToTop() {
	window.scrollTo({ top: 0, behavior: 'smooth' })
}
</script>

<template>
	<div class="back-to-top">
		<transition name="fade">
			<div v-show="showScrollTop">
				<ActionButton
					context="primary"
					icon="chevron-up"
					hide-text
					@click="scrollToTop"
				>
					Scroll to top
				</ActionButton>
			</div>
		</transition>
	</div>
</template>
